import { render } from "./AddArtworkWizard.vue?vue&type=template&id=b211b3aa&scoped=true"
import script from "./AddArtworkWizard.vue?vue&type=script&lang=js"
export * from "./AddArtworkWizard.vue?vue&type=script&lang=js"

import "./AddArtworkWizard.vue?vue&type=style&index=0&id=b211b3aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b211b3aa"]])

export default __exports__